export const scheduleData = [
    { label: "Competition Launch", value: "October 30th, 2025" },
    { label: "Registration Deadline", value: "January 30th, 2026" },
    { label: "Submission Deadline", value: "January 30th, 2026" },
    { label: "Winners Announcement", value: "March 15th, 2026" },
  ];
  
  export const prizeData = [
    { label: "1st Prize", value: "$1,000 + Certificate + Interview  + Publication" },
    { label: "2nd Prize", value: "$500 + Certificate + Interview  + Publication" },
    { label: "3rd Prize", value: "$300 + Certificate + Interview  + Publication" },
    { label: "10 Honorable Mentions", value: "Certificates + Publication" },
    { label: "Best Student Award", value: "Certificates + Publication" },
  ];
  
